module.exports = __webpack_public_path__ + "static/kaoqin-d8fc93e2f135cd4d4e7de8b71a0d3982.png";